module.exports = __webpack_public_path__ + "img/logo_agleventis_foundation.9f2d590c.jpg";